import React, { useState } from 'react'
import {
  Row,
  Col,
  Spin,
  Button,
  Form,
  Input,
  Select,
  Divider,
  Radio,
  message,
  Modal,
  InputNumber
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import { useHistory } from 'react-router-dom'
import { ArrowLeftOutlined } from '@ant-design/icons'
import ds from '../../../Services/DataServices'
import { useDispatch, useSelector } from 'react-redux'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { OUTLETREGISTER_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { getDecryptID, notAllowMsgCheck } from '../../../appRedux/actions'
import { IN_HOUSE_PAY } from '../../../constants/StoreSetting'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const confirm = Modal.confirm

const AddEditRegister = ({ match }) => {
  const regID =
    match.params.id && window.location.href.includes('editregister')
      ? match.params.id
      : false
  const outletID =
    match.params.id && window.location.href.includes('addregister')
      ? match.params.id
      : false
  const isDelOutlet =
    match.params.isDelOutlet && window.location.href.includes('editregister')
      ? match.params.isDelOutlet
      : false
  const history = useHistory()
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxTemplatedData = useSelector(
    ({ Setup }) => Setup.receiptTemplatesData
  )
  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [confirmLoading, setConfirmLoading] = useState(true) // change state
  const [nextSaleRadioButton, setNextSaleRadioButton] = useState(2)
  const [getEmailReceipt, setEmailReceipt] = useState(2)
  const [getPrintReceipt, setPrintReceipt] = useState(1)
  const [getShowDiscounts, setShowDiscounts] = useState(2)
  const [getPrintNote, setPrintNote] = useState(2)
  const [getRegName, setRegName] = useState('')
  const [isAddReg, setisAddReg] = useState(false)
  const [getPaymentTypes, setPaymentTypes] = useState([])
  const [getTemplatesList, setTemplatesList] = useState([])
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getPayList, setPayList] = useState([])
  const [getOutletName, setOutletName] = useState('')

  const validateLength = (_, value) => {
    if (!value || value.toString().length <= 10) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Number must be at most 20 digits.'));
  };

  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(
        PostAppTypes.PAGE_HEADER,
        'setup.salesTax.addEditRegisterTitle'
      )
    }

    dispatch(setCommonConfigs(OUTLETREGISTER_SCREEN))
    getPaymentTypesService('0')
    // form.setFieldsValue({ CashManagement: 1 });
    if (window.location.href.includes('addregister')) {
      setisAddReg(true)
    }
    if (regID) {
      let body = {
        RegID: regID
      }
      getRegService(body)
    } else {
      setConfirmLoading(false)
    }
  }, [])

  React.useEffect(() => {
    if (getReduxTemplatedData && getReduxTemplatedData.length > 0) {
      let data = getReduxTemplatedData.map(e => {
        return {
          id: e.templateID.substring(0, e.templateID.indexOf('&')),
          value: e.templateName
        }
      })

      setTemplatesList(data)
    }
  }, [getReduxTemplatedData])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
        //redirect from home
        // if (window.location.href.includes("/mainadd")) {
        //   setVisible(true);
        // }
      }
      // else {
      //   if (window.location.href.includes("/mainadd")) {
      //     message.info("User don't have the right to create.");
      //   }
      // }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  async function getPaymentTypesService (isMain) {
    const createReq = ds.getCommonPaymentTypesService(
      isMain,
      BEHAVIOUR_TYPE.GET
    )
    await createReq
      .then(res => {
        if (res && res.length > 0) {
          let data = res
            .filter(
              ww =>
                ww.gatewayName != IN_HOUSE_PAY.loyalty_gateway &&
                ww.gatewayName != IN_HOUSE_PAY.store_gateway
            )
            .map(e => {
              return {
                name: e.paymentTypeName,
                id: e.sPaymentTypeId.substring(0, e.sPaymentTypeId.indexOf('&'))
              }
            })
          setPaymentTypes(data)
          setPayList(res)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
        // console.error("PayReqStatus", e);
        // message.error("Failed, report this & Try later");
      })
  }

  async function getRegService (body) {
    // ;
    await ds
      .getOutletAndRegister(body, BEHAVIOUR_TYPE.GET)
      .then(res => {
        setConfirmLoading(false)
        if (res.outletAndRegisterLists.length > 0) {
          let resData = res.outletAndRegisterLists[0]
          if (resData.registerInfo && resData.registerInfo.length > 0) {
            let data = resData.registerInfo[0]
            setRegName(data.registerName ? data.registerName : '')
            setOutletName(data.outletName ? data.outletName : '')
            form.setFieldsValue({
              RegisterName: data.registerName ? data.registerName : '',
              CashManagement: data.paymentSId
                ? data.paymentSId.substring(0, data.paymentSId.indexOf('&'))
                : '',
              Number: data.number ? data.number : '',
              Prefix: data.prefix ? data.prefix : '',
              Suffix: data.suffix ? data.suffix : '',
              Template: data.receiptTemplateID
                ? data.receiptTemplateID.substring(
                    0,
                    data.receiptTemplateID.indexOf('&')
                  )
                : '1'
            })
            setNextSaleRadioButton(data.selectUserForNextSale == true ? 1 : 2)
            setPrintReceipt(data.printReceipt == true ? 1 : 2)
            setPrintNote(data.printNoteOnReceipt == true ? 1 : 2)
            setEmailReceipt(data.isEmailReceipt == true ? 1 : 2)
            setShowDiscounts(data.showDiscountsOnReceipts == true ? 1 : 2)
          }
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        message.error('Something went wrong')
        setConfirmLoading(false)
      })
  }

  async function postRegService (body, methodType) {
    // ;
    await ds
      .postOutletAndRegister(body, methodType)
      .then(res => {
        if (res == 'Saved') {
          setConfirmLoading(false)
          message.success('Register Updated Successfully')
          updateLocalStorageForReg()
          setTimeout(() => {
            redirectToListing()
          }, 2000)
        } else if (res.includes('Deleted')) {
          setConfirmLoading(false)
          if (res.includes('Outlet')) {
            message.success('Register & Outlet Deleted Successfully')
          } else {
            message.success('Register Deleted Successfully')
          }
          setTimeout(() => {
            redirectToListing()
          }, 2000)
        } else if (res.includes('Created')) {
          setConfirmLoading(false)
          message.success('Register Created Successfully')
          setTimeout(() => {
            redirectToListing()
          }, 2000)
        } else if (res.includes('is open')) {
          setConfirmLoading(false)
          message.warn('Cannot delete because the register is Open', 4)
          // setTimeout(() => {
          //   redirectToListing();
          // }, 2000);
        } else {
          setConfirmLoading(false)
          message.warn('Server down, Try Again Later...')
        }
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
        message.error('Something went wrong...')
      })
  }

  function updateLocalStorageForReg () {
    const reg = localStorage.getItem('selectedReg')
      ? JSON.parse(localStorage.getItem('selectedReg'))
      : false
    if (reg) {
      if (!isAddReg && regID) {
        const isSame = reg.id
          ? getDecryptID(reg.id) == getDecryptID(regID)
          : false
        if (isSame) {
          reg.printNoteOnReceipt = getPrintNote == 1 ? true : false
          reg.printReceipt = getPrintReceipt == 1 ? true : false
          reg.selectUserForNextSale = nextSaleRadioButton == 1 ? true : false
          reg.showDiscountsOnReceipts = getShowDiscounts == 1 ? true : false
          reg.suffix = form.getFieldValue('Suffix')
            ? form.getFieldValue('Suffix').toString()
            : ''
          reg.prefix = form.getFieldValue('Prefix')
            ? form.getFieldValue('Prefix').toString()
            : ''
          reg.number = form.getFieldValue('Number')
            ? form.getFieldValue('Number').toString()
            : ''

          localStorage.setItem('selectedReg', JSON.stringify(reg))
        }
      }
    }
  }

  const OnChangeNextSaleRadioButton = e => {
    setNextSaleRadioButton(e.target.value)
  }

  const redirectToListing = () => {
    history.push('/Dashboard/Setup/outletsandregisters/listing')
  }

  function onDeleteConfirm () {
    if (regID) {
      let body = {
        Behavior: 2,
        RegID: regID,
        DelOutletAsWell: isDelOutlet == '1' ? true : false
      }
      setConfirmLoading(true)
      postRegService(body, BEHAVIOUR_TYPE.DELETE)
    } else {
      message.error('Connection broke...')
      setTimeout(() => {
        redirectToListing()
      }, 2000)
    }
  }

  function showDeleteConfirm () {
    confirm({
      title: 'Are you sure to delete this Register?',
      content: `"${getRegName}"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        onDeleteConfirm()
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  const onFinishFailed = errorInfo => {
    message.error('Kindly attend to missing fields...')
  }

  const onFinish = values => {
    const methType = isAddReg ? BEHAVIOUR_TYPE.POST : BEHAVIOUR_TYPE.UPDATE
    const payTypeID =
      getPayList && getPayList.length > 0
        ? getPayList.filter(
            a => getDecryptID(a.sPaymentTypeId) == values.CashManagement
          )[0].sPaymentTypeId
        : ''
    let behaviorData = isAddReg ? 1 : 3
    let body = {
      Behavior: behaviorData,
      OutletId: isAddReg ? outletID : '',
      RegName: values.RegisterName,
      RegID: isAddReg ? '' : regID,
      ShowDiscountsOnReceipts: getShowDiscounts == 1 ? true : false,
      PrintNoteOnReceipt: getPrintNote == 1 ? true : false,
      PrintReceipt: getPrintReceipt == 1 ? true : false,
      IsEmailReceipt: getEmailReceipt == 1 ? true : false,
      SelectUserForNextSale: nextSaleRadioButton == 1 ? true : false,
      Suffix: values.Suffix ? values.Suffix.toString() : '',
      Prefix: values.Prefix ? values.Prefix.toString() : '',
      Number: values.Number ? values.Number.toString() : '',
      ReceiptTemplateID: values.Template ? values.Template : '',
      PayTypeID: payTypeID
    }
    setConfirmLoading(true)
    postRegService(body, methType)

    // if (regID) {

    // } else {
    //   message.error("Connection broke...");
    //   setTimeout(() => {
    //     redirectToListing();
    //   }, 2000);
    // }
  }

  return getIsAllowRead ? (
    <Spin spinning={confirmLoading} size='large'>
      <>
        <div className='Content-wrapper AddEdit-Reg'>
          {checkIsWeb().exist && (
            <div className='back-arrow-h1'>
              <h1 className='d-flex align-items-center'>
                <ArrowLeftOutlined
                  className='dk-vertical-align'
                  onClick={redirectToListing}
                />
                <span className='mx-2'>
                  <IntlMessages id='setup.salesTax.addEditRegisterTitle' />{' '}
                  {getOutletName}
                </span>
              </h1>
            </div>
          )}

          <Form
            {...formItemLayout}
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={{
              prefix: '86',
              Template: '1'
            }}
            className=''
            scrollToFirstError
            id='AddEditRegisterForm'
            name='AddEditRegisterForm'
          >
            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
              <IntlMessages id='setup.salesTax.editOutletSubTitle1' />
            </h2>

            <Row>
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='RegisterName'
                  label={
                    <IntlMessages id='setup.salesTax.addRegister.Label1' />
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Required'
                    }
                  ]}
                >
                  <Input  maxLength={50}/>
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='CashManagement'
                  label={
                    <IntlMessages id='setup.salesTax.addRegister.Label2' />
                  }
                  rules={[
                    {
                      required: true,
                      message: 'Required'
                    }
                  ]}
                >
                  <Select
                    placeholder={
                      <IntlMessages id='setup.salesTax.addRegister.Label2' />
                    }
                  >
                    {getPaymentTypes &&
                      getPaymentTypes.length > 0 &&
                      getPaymentTypes.map((e, key) => {
                        return (
                          <Select.Option key={key} value={e.id}>
                            {e.name}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
              <IntlMessages id='setup.salesTax.addEditRegisterSubTitle2' />
            </h2>

            <Row>
              {getTemplatesList && getTemplatesList.length > 0 && (
                <Col
                  lg={12}
                  md={12}
                  sm={24}
                  xs={24}
                  className='form-inner-pad-0 pl-0-device'
                >
                  <Form.Item
                    className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                    name='Template'
                    label={
                      <IntlMessages id='setup.salesTax.addRegister.Label3' />
                    }
                    rules={[
                      {
                        required: true,
                        message: 'Required'
                      }
                    ]}
                  >
                    <Select
                      placeholder={
                        <IntlMessages id='setup.salesTax.addRegister.Label3' />
                      }
                    >
                      {getTemplatesList.map((e, key) => {
                        return (
                          <Select.Option key={key} value={e.id}>
                            {e.value}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              )}
              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='Number'
                  label={
                    <IntlMessages id='setup.salesTax.addRegister.Label4' />
                  }
                  rules={[
                    { validator: validateLength },
                  ]}
                >
                  <InputNumber type="number" style={{ width: '100%' }}/>
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='Prefix'
                  label={
                    <IntlMessages id='setup.salesTax.addRegister.Label5' />
                  }
                  help={
                    <IntlMessages id='setup.salesTax.addRegister.LabelDesc' />
                  }
                >
                  <Input style={{ width: '100%' }}  maxLength={10} />
                </Form.Item>
              </Col>

              <Col
                lg={12}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <Form.Item
                  className='ant-form-item-label-custom ant-form-margin-right row-col-100'
                  name='Suffix'
                  label={
                    <IntlMessages id='setup.salesTax.addRegister.Label6' />
                  }
                  help={
                    <IntlMessages id='setup.salesTax.addRegister.LabelDesc' />
                  }
                >
                  <Input style={{ width: '100%' }} maxLength={10} />
                </Form.Item>
              </Col>
            </Row>

            <Divider className='mt-3 mb-4' />

            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
              <IntlMessages id='setup.salesTax.addEditRegisterSubTitle3' />
            </h2>

            <Row>
              <Col
                lg={6}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <p className='mb-0'>
                  <IntlMessages id='setup.salesTax.addRegister.Label10' />
                </p>

                <Radio.Group
                  style={{ display: 'inline-grid' }}
                  size='large'
                  value={getPrintReceipt}
                  onChange={e => {
                    setPrintReceipt(e.target.value)
                  }}
                >
                  <Row>
                    <Radio value={1}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn1' />
                    </Radio>

                    <Radio value={2}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn2' />
                    </Radio>
                  </Row>
                </Radio.Group>
              </Col>

              <Col
                lg={6}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device'
              >
                <p className='mb-0 mt-10-md'>
                  <IntlMessages id='setup.salesTax.addRegister.Label13' />
                </p>

                <Radio.Group
                  style={{ display: 'inline-grid' }}
                  size='large'
                  value={getShowDiscounts}
                  onChange={e => {
                    setShowDiscounts(e.target.value)
                  }}
                >
                  <Row>
                    <Radio value={1}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn1' />
                    </Radio>

                    <Radio value={2}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn2' />
                    </Radio>
                  </Row>
                </Radio.Group>
              </Col>

              <Col
                lg={6}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pl-0-device'
              >
                <p className='mb-0 mt-10-md'>
                  <IntlMessages id='setup.salesTax.addRegister.Label9' />
                </p>

                <Radio.Group
                  style={{ display: 'inline-grid' }}
                  size='large'
                  value={getEmailReceipt}
                  onChange={e => {
                    setEmailReceipt(e.target.value)
                  }}
                >
                  <Row>
                    <Radio value={1}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn1' />
                    </Radio>

                    <Radio value={2}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn2' />
                    </Radio>
                  </Row>
                </Radio.Group>
              </Col>

              <Col
                lg={6}
                md={12}
                sm={24}
                xs={24}
                className='form-inner-pad-0 pr-0-device '
              >
                <p className='mb-0 mt-10-md'>
                  <IntlMessages id='setup.salesTax.addRegister.Label12' />
                </p>

                <Radio.Group
                  style={{ display: 'inline-grid' }}
                  size='large'
                  value={getPrintNote}
                  onChange={e => {
                    setPrintNote(e.target.value)
                  }}
                >
                  <Row>
                    <Radio value={1}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn1' />
                    </Radio>

                    <Radio value={2}>
                      <IntlMessages id='setup.salesTax.addEditRegisterRadioBtn2' />
                    </Radio>
                  </Row>
                </Radio.Group>
              </Col>
            </Row>

            <Row className='mt-5' justify='end' gutter={10}>
              <Col>
                <Button
                  className='dk-btn-cancel'
                  onClick={redirectToListing}
                  type='primary'
                  size='large'
                >
                  <IntlMessages id='products.promoadd.canbtn' />
                </Button>
              </Col>
              {regID && isDelOutlet != '2' && (
                <Col>
                  <Button
                    className='dk-btn-cancel'
                    type='primary'
                    onClick={showDeleteConfirm}
                    size='large'
                    disabled={getIsDisableDelete}
                  >
                    {isDelOutlet == '1' ? (
                      <IntlMessages id='setup.userroles.deleteoutletaswell' />
                    ) : (
                      <IntlMessages id='setup.userroles.delete' />
                    )}
                  </Button>
                </Col>
              )}
              <Col>
                <Button
                  className='dk-btn-add'
                  htmlType='submit'
                  type='primary'
                  size='large'
                  disabled={isAddReg ? getIsDisableCreate : getIsDisableUpdate}
                >
                  <IntlMessages id='products.promoadd.savbtn' />
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </>
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default AddEditRegister
